module.exports = __webpack_public_path__ + "img/E-WEB-Goal-06.553fdba9.png";